<template>
  <div class="not-connected flex d-flex flex-column justify-center align-center text-center my-4">
    <template v-if="!roomConnection">
      <aside class="mb-4">
        <v-progress-circular
          indeterminate
          color="primary"
          size="45"
        ></v-progress-circular>
      </aside>
      <h3>Verbindung wird hergestellt ...</h3>
    </template>

    <template v-else-if="roomConnection.statusCode === 404">
      <aside class="mb-4">
        <v-icon color="secondary">fad fa-stream</v-icon>
      </aside>
      <h3>Raum "{{roomId}}" existiert nicht oder wurde gelöscht</h3>
      <v-btn color="accent" class="my-4" :to="'/share/rooms'" depressed>
        <v-icon class="mr-2">far fa-stream</v-icon>
        Raum wechseln
      </v-btn>
    </template>

    <template v-else-if="roomConnection.statusCode === 410">
      <aside class="mb-4">
        <v-icon color="secondary">fad fa-stream</v-icon>
      </aside>
      <h3>Raum "{{roomConnection.room ? roomConnection.room.name : roomId}}" wurde gelöscht</h3>
      <v-btn color="accent" class="my-4" :to="'/share/rooms'" depressed>
        <v-icon class="mr-2">far fa-stream</v-icon>
        Raum wechseln
      </v-btn>
    </template>

    <template v-else-if="roomConnection.statusCode === 400">
      <aside class="mb-4">
        <v-icon color="secondary">fad fa-link</v-icon>
      </aside>
      <h3 class="mb-2">Ungültiger oder abgelaufener Link</h3>
      <p>
        Raum "{{roomConnection.room ? roomConnection.room.name : roomId}}" konnte nicht beigetreten werden.
      </p>
      <v-btn color="accent" class="my-4" :to="'/share/rooms'">
        <v-icon class="mr-2">far fa-stream</v-icon>
        Raum wechseln
      </v-btn>
    </template>

    <template v-else-if="roomConnection.statusCode === 403">
      <aside class="mb-4">
        <v-icon color="secondary">fad fa-link</v-icon>
      </aside>
      <h3 class="mb-2">Keine Berechtigung</h3>
      <p>
        Dein Konto hat keine Berechtigung für den Raum "{{roomConnection.room ? roomConnection.room.name : roomId}}".<br>
        Überprüfe ob du mit dem richtigen Konto eingeloggt bist<br>
        oder wechsle in einen anderen Raum.
      </p>
      <v-btn color="accent" class="mt-4" :href="`/select-account?state=${encodeURIComponent(`login_redir=${$route.fullPath}`)}`">
        <v-icon class="mr-2">far fa-user</v-icon>
        Konto wechseln
      </v-btn>
      <div class="my-2">oder</div>
      <v-btn color="accent" class="mb-4" :to="'/share/rooms'">
        <v-icon class="mr-2">far fa-stream</v-icon>
        Raum wechseln
      </v-btn>
    </template>

    <template v-else-if="roomConnection.statusCode === 409">
      <aside class="mb-4">
        <v-icon color="secondary">fad fa-link</v-icon>
      </aside>

      <h3 class="mb-2">Gerät bereits verbunden</h3>
      <p class="text-center">
        Dieses Gerät hat bereits eine aktive Verbindung in einem anderen Tab,
        jedoch ist pro Gerät nur eine Verbindung erlaubt.<br>
        Du kannst die bestehende Verbindung trennen und hier fortfahren.<br>
        <small class="d-flex align-center justify-center text--warning mt-2">
          <v-icon small color="warning" class="mr-2">far fa-exclamation-triangle</v-icon>
          <span>Dies bricht alle Übertragungen der aktiven Verbindung ab.</span>
        </small>
      </p>
      <v-btn color="primary" depressed small @click.prevent="forceRoomConnect">
        <v-icon small class="mr-2">far fa-unlink</v-icon>
        Aktive Verbindung trennen
      </v-btn>
    </template>

    <template v-else-if="roomConnection.statusCode === 0">
      <aside class="mb-4">
        <v-icon color="secondary">fad fa-wifi-slash</v-icon>
      </aside>
      <h3 class="mb-2">Verbindung unterbrochen</h3>
      <p>Es wird versucht die Verbindung wiederherzustellen ...</p>
    </template>

    <template v-else>
      <aside class="mb-4">
        <v-icon color="secondary">fad fa-wifi-slash</v-icon>
      </aside>
      <h3 class="mb-2">Verbindung fehlgeschlagen</h3>
      <p>Es konnte keine Verbindung hergestellt werden.</p>
    </template>
  </div>
</template>

<script>
  import eventBus from '../assets/js/event-bus';

  export default {
    name: 'NotConnected',

    computed: {
      roomConnection() {
        return this.$store.getters['share/getRoomConnection'];
      },

      roomId() {
        return this.$route.query.room;
      }
    },

    methods: {
      forceRoomConnect() {
        eventBus.$emit('forceRoomConnect');
      }
    }
  };
</script>
